/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 140px;
  padding: 10px 25px;
  gap: 10px;
  background: ${({ theme }) => theme.textfield.background};
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 14;
  font-weight: 600;
  color: ${({ theme }) => theme.textfield.text};
`;
Title.displayName = 'Title';

export const ContainerFields = styled.div`
  display: flex;
  gap: 30px;
`;
ContainerFields.displayName = 'ContainerFields';

export const Label = styled.div`
  font-size: 12.5px;
  color: ${({ theme }) => theme.textfield.text};
`;
Label.displayName = 'Label';

export const Value = styled.div`
  min-width: 30px;
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.buttons.primary.background};

`;
Value.displayName = 'Value';

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
Fields.displayName = 'Fields';

export const Values = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
Values.displayName = 'Values';
